module.exports = __webpack_public_path__ + "static/media/CL 15.70910ee7.mp3";